<template>
  <div class="admin-layout d-flex flex-column flex-md-row min-vh-100">
    <!-- Admin Navigation Component -->
    <AdminMenu :user-email="authStore.user?.email"/>

    <!-- Main Content Area -->
    <main class="admin-main-content flex-grow-1 p-3 p-md-4 min-vh-100">
      <AdminOverview v-if="activeSection === 'overview'"/>
      <AdminReservations v-if="activeSection === 'reservations'"/>
      <AdminSpaces v-if="activeSection === 'spaces'"/>
      <AdminEvents v-if="activeSection === 'events'"/>
      <AdminUsers v-if="activeSection === 'users'"/>
      <AdminPrices v-if="activeSection === 'prices'"/>
    </main>
  </div>
</template>

<script>
import AdminMenu from './AdminMenu.vue'
import AdminOverview from './AdminOverview.vue'
import AdminReservations from './reservations/AdminReservations.vue'
import AdminSpaces from './AdminSpaces.vue'
import AdminEvents from './AdminEvents.vue'
import AdminUsers from './AdminUsers.vue'
import AdminPrices from './AdminPrices.vue'
import {useAuthStore} from '@/stores/auth'

export default {
  name: 'AdminDashboard',
  components: {
    AdminMenu,
    AdminOverview,
    AdminReservations,
    AdminSpaces,
    AdminEvents,
    AdminUsers,
    AdminPrices
  },
  setup() {
    const authStore = useAuthStore()
    return {authStore}
  },
  computed: {
    activeSection() {
      const path = this.$route.path
      if (path.includes('/reservations')) return 'reservations'
      if (path.includes('/spaces')) return 'spaces'
      if (path.includes('/events')) return 'events'
      if (path.includes('/users')) return 'users'
      if (path.includes('/prices')) return 'prices'
      return 'overview'
    }
  }
}
</script>

<style scoped>
.admin-layout {
  min-height: 100vh;
}
</style>